export type FaqItem = {
  question: string
  answer: string
}

export const faq: FaqItem[] = [
  {
    question: 'Ho bisogno di esperienza nella gestione di un’attività?',
    answer:
      'No. Il sistema è progettato per tecnici che desiderano organizzare meglio il proprio lavoro senza avere conoscenze di amministrazione o contabilità.',
  },
  {
    question: 'Funziona in qualsiasi Paese?',
    answer:
      'Sì. I sistemi, i processi e le risorse possono essere adattati al modo in cui lavori e alle esigenze della tua attività.',
  },
  {
    question: 'Come riceverò il materiale?',
    answer:
      'Dopo aver completato l’acquisto, riceverai accesso immediato al materiale digitale.',
  },
  {
    question: 'Il pagamento è unico?',
    answer: 'Sì. Effettui un solo pagamento. Non ci sono abbonamenti mensili.',
  },
  {
    question: 'I file sono modificabili?',
    answer:
      'Sì. Le risorse incluse sono progettate per permetterti di personalizzarle in base alla tua attività.',
  },
]
